export default {
    namespaced: true,
    state: {
        isUpdatePwdShow: false,
    },
    mutations: {
        SET_PWD(state, params) {
            state.isUpdatePwdShow = params
        },
    },
    actions: {
        UPDATEPWD({ commit }, params) {
            commit('SET_PWD', params);
        },
    },
    getters: {
        isUpdatePwdShow: state => state.isUpdatePwdShow,
    },
};